import {FileConfiguration} from '../../file/message/FileConfiguration';
import {PredefinedBaseConfiguration} from './PredefinedBaseConfiguration';

export class WriteWitnessFileConfiguration extends PredefinedBaseConfiguration {
file: FileConfiguration;
}

